import { HourResponse } from '../models/HourResponse';

export class Hour {
	weekday: number;
	openedAt: Date;
	closedAt: Date;

	constructor(hourRes: HourResponse, currWeekDay: number) {
		const hourResWeekDay = hourRes.weekday === 6 ? 0 : hourRes.weekday + 1;
		if (!hourRes?.openedAt || !hourRes?.closedAt) return null;

		const openedAt = new Date();
		const closedAt = new Date();

		openedAt.setDate(openedAt.getDate() + hourResWeekDay - 1 - currWeekDay);
		closedAt.setDate(closedAt.getDate() + hourResWeekDay - 1 - currWeekDay);

		openedAt.setHours(+hourRes.openedAt.split(':')[0] + 2, +hourRes.openedAt.split(':')[1], 0);
		closedAt.setHours(+hourRes.closedAt.split(':')[0] + 2, +hourRes.closedAt.split(':')[1], 0);

		if (currWeekDay > hourResWeekDay) {
			//For days of the week that have already passed, we set the day from the following week.
			openedAt.setDate(openedAt.getDate() + 7);
			closedAt.setDate(closedAt.getDate() + 7);
		}

		if (openedAt.getTime() > closedAt.getTime() && closedAt.getDay() !== hourResWeekDay)
			openedAt.setDate(closedAt.getDate() - 1);
		else if (openedAt.getTime() > closedAt.getTime() && closedAt.getDay() === hourResWeekDay)
			openedAt.setDate(closedAt.getDate());

		this.weekday = hourRes.weekday;
		this.openedAt = openedAt;
		this.closedAt = closedAt;
	}
}
